import Reports from 'Modules/contacard/reports/routes';
import Informatives from 'Modules/contacard/informatives/routes';
import Banks from 'Modules/contacard/banks/routes';
import Banners from 'Modules/contacard/banners/routes';
import Communication from 'Modules/contacard/communication/routes';
import Faq from 'Modules/contacard/faq/routes';
import Produto from 'Modules/contacard/produto/routes';
import { buildModuleRoute } from 'Arch/helpers/RouterHelper';
import Company from 'Modules/contacard/company/routes';
import Conciliations from 'Modules/contacard/conciliations/routes';
import Holidays from 'Modules/contacard/holidays/routes';
import Segmentos from 'Modules/contacard/segmento/routes';
// import Cards from 'Modules/contacard/cards/routes';
import LogoCardMais from 'Assets/cardmais.svg';
import Limits from 'Modules/contacard/limits/routes';
import LegalAgreements from 'Modules/contacard/legalAgreements/routes';
import AnalysisTable from 'Modules/contacard/analysisTable/routes';
import Shortlist from 'Modules/contacard/shortlist/routes';
import Adq from 'Modules/contacard/adq/routes';
import Terminais from 'Modules/contacard/terminal/routes';
import Installment from 'Modules/contacard/installment/routes';
import Reversal from 'Modules/contacard/reversal/routes';
import CardBilling from 'Modules/contacard/card-billing/routes';
import Blacklist from 'Modules/contacard/blacklist/routes';
import Qrcodes from 'Modules/contacard/qrcode/routes';

export default [
  buildModuleRoute({
    path: '/contacard',
    moduleId: 'contacard',
    moduleName: 'CardMais',
    moduleIcon: 'mdi-dns',
    moduleLogo: LogoCardMais,
    children: [
      ...Adq,
      ...AnalysisTable,
      ...Banks,
      ...Banners,
      ...Communication,
      ...Faq,
      ...Informatives,
      ...Reports,
      ...Produto,
      ...Company,
      ...Conciliations,
      ...Holidays,
      ...Segmentos,
      // ...Cards,
      ...Limits,
      ...LegalAgreements,
      ...Shortlist,
      ...Terminais,
      ...Installment,
      ...Reversal,
      ...CardBilling,
      ...Blacklist,
      ...Qrcodes,
    ],
  }),
];
